module.exports = __webpack_public_path__ + "static/FishScales-0b23b1edef4cb0717575c10de4c93ef9.jpg";